import React, {Component} from 'react';
import { extend } from 'lodash';
import { webshop } from './webshop';

class HitsGridItem extends Component {

  onClick(id, ev) {
    this.props.onClick(id, ev);
  }

  onClose(id, ev) {
    this.props.onClose(id, ev);
  }

  render() {
    const {result, current, currency, lang} = this.props;
    const source = extend({}, result._source, result.highlight);
    const imageUrl = Array.isArray(result._source.thumbs) ? [webshop.cdn, result._source.thumbs[0]].join('') : result._source.thumbs;
    const imageLength = Array.isArray(result._source.thumbs) ? result._source.thumbs.length : 1;
    const price = currency ? currency + source.price : source.price;

    let campaignImage;
    if (source.campaignImage) {
      campaignImage = <img className="ws-preview-campaign-image" data-qa="thumb" src={[webshop.cdn, source.campaignImage].join('')} width="70" height="70"/>;
    }
    
    let salePrice;
    if (source.discountPrice && source.discountPrice.length > 1) {
      salePrice = <span className="ws-price-discount">{source.discountPrice}</span>
    }

    let hitClass = "col-xl-3 col-lg-4 col-sm-4 col-6 ws-hit";
    if (current === source.id) {
      hitClass += " ws-hit-active";
    }

    let thumbs;
    let galleryClass = "ws-preview-gallery col-lg-3 col-md-3"
    if (imageLength > 1) {
      galleryClass += " ws-preview-gallery-tall"
      thumbs = <div className="ws-preview-thumbs hidden-md-down">
        <div className="ws-preview-thumb">
          <img className="ws-preview-thumb-image" data-qa="thumb" src={imageUrl} width="70" height="70"/>
        </div>
      </div>
    }

    return (
      <div className={hitClass} data-qa="hit">
        <div className="ws-hit-link" onClick={this.onClick.bind(this, source.id)}>
          <div className="ws-hit-media">
            <img data-qa="poster" className="ws-hit-poster" alt={source.name} src={imageUrl} width="170" height="240"/>
          </div>
          <div className="ws-hit-details">
            <strong data-qa="price" className="hidden-md-up ws-hit-price" dangerouslySetInnerHTML={{__html:price}}></strong>
            <h4 data-qa="title" className="ws-hit-title" title={source.name} dangerouslySetInnerHTML={{__html:source.name}}></h4>
            <div className="ws-hit-attrs row">
              <span data-qa="shop" className="col-12 col-md-6 ws-hit-shop" title={source.campaign} dangerouslySetInnerHTML={{__html:source.campaign}}></span>
              <strong data-qa="price" className="col-12 col-md-6 hidden-sm-down ws-hit-price" title={price} dangerouslySetInnerHTML={{__html:price}}></strong>
            </div>
          </div>
          <div className="ws-arrow">
            <span className="ws-arrow__icon"></span>
          </div>
        </div>
        <div className="ws-preview">
          <div className="ws-preview-inner">
            <div className="ws-preview-close">
              <span className="ws-preview-close__icon" onClick={this.onClose.bind(this)}></span>
            </div>
            <div className="ws-preview-details col-lg-5 col-md-5">
              <h3 className="ws-preview-name" title={source.name} dangerouslySetInnerHTML={{__html:source.name}}></h3>
              <p className="ws-preview-desc hidden-sm-down" dangerouslySetInnerHTML={{__html:source.description}}></p>
              <div className="ws-price ws-price-inline ws-price-sm hidden-md-up">
                {salePrice}
                <strong className="ws-price-current">{price}</strong>
              </div>
            </div>
            <div className={galleryClass}>
              <div className="ws-preview-current">
                <img className="ws-preview-poster" data-qa="poster" src={imageUrl} width="155" height="220"/>
              </div>
              {thumbs}
            </div>
            <div className="ws-preview-action col-lg-4 col-md-4">
              <ul className="ws-preview-attrs hidden-sm-down">
                <li className="ws-preview-campaign-logo">{campaignImage}</li>
                <li className="ws-price">
                  {salePrice}
                  <strong className="ws-price-current">{price}</strong>
                </li>
              </ul>
              <a href={source.url} target="_blank" title={source.campaign} className="btn btn-primary btn-lg">{lang.goto} {source.campaign}</a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default HitsGridItem;



// WEBPACK FOOTER //
// ./src/HitsGridItem.js